import React from 'react';
import { format } from 'date-fns';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { APP_TYPE_DEFAULT } from '../../forms-system/src/js/constants';

export default function DowntimeMessage({
  downtime,
  isAfterSteps,
  formConfig,
  headerLevel = 3,
}) {
  const { endTime } = downtime;
  const endDate = endTime ? new Date(endTime) : null;
  const appType = formConfig?.customText?.appType || APP_TYPE_DEFAULT;
  const Header = `h${headerLevel}`;
  return (
    <va-alert
      class={classNames({
        'schemaform-downtime-after-steps': isAfterSteps,
      })}
      isVisible
      status="warning"
      uswds
    >
      <Header slot="headline">
        {`This ${appType} is down for maintenance.`}
      </Header>
      {endTime ? (
        <p>
          We’re making some updates to this {appType}. We’re sorry it’s not
          working right now, and we hope to be finished by{' '}
          {format(endDate, 'MMMM do, h:mm aaaa')} Please check back soon.
        </p>
      ) : (
        <p>
          We’re making some updates to this {appType}. We’re sorry it’s not
          working right now. Please check back soon.
        </p>
      )}
    </va-alert>
  );
}

DowntimeMessage.propTypes = {
  downtime: PropTypes.shape({
    endTime: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Date),
    ]),
  }),
  formConfig: PropTypes.shape({
    customText: PropTypes.shape({
      appType: PropTypes.string,
    }),
  }),
  headerLevel: PropTypes.number,
  isAfterSteps: PropTypes.bool,
};
